export default __webpack_public_path__ + "static/media/downloadFileIcon.a493d9af.svg";